<div class="boxContainer">
  <header>
    <nav class="bottom-header">
      <ul>
        <li>
          <h2 class="boxContainer_titulo">{{ pageTitle }}</h2>
        </li>
        <li>
          <a href="#"><i class="fa-solid icones fogo fa-fire"></i> Em alta</a>
        </li>
        <li class="icon-text">
          <a href="#">
            <img
              class="icon-img"
              src="../../../assets/images/acessibilidade.png"
              alt=""
            />
            Acessibilidade
          </a>
        </li>
        <li>
          <a href="#"
            ><i class="fa-solid icones crianca fa-face-laugh-beam"></i>
            Crianças</a
          >
        </li>
        <li>
          <a href="#"
            ><i class="fa-solid icones esporte fa-basketball"></i> Esportes</a
          >
        </li>
        <li>
          <a href="#"><i class="fas icones aula fa-heartbeat"></i> Aulas</a>
        </li>
        <li>
          <button class="btn btn-outline-secondary">
            <i class="icone fa-solid fa-filter"></i>
            Filtros
          </button>
        </li>
        <li>
          <button class="btn btn-outline-secondary">
            <i class="icone fa-solid fa-filter"></i>
            Limpar Filtros
          </button>
        </li>
      </ul>
    </nav>
  </header>

  <div class="boxes">
    <div class="itens">
      <ul class="configuracoesList">
        <ng-container *ngFor="let item of paginatedItems">
          <a [routerLink]="['/info/filtro', item.name, { image: item.image }]">
            <li class="configuracoesList_item">
              <img [src]="item.image" class="configuracoesList_item_icon" />
              <div class="infos">
                <div class="top-info">
                  <div class="rating">
                    <i class="fa-solid fa-star"></i>
                    {{ item.stars }}
                  </div>
                  <div class="distance">{{ item.distancia }} metros</div>
                </div>
                <div class="name">
                  <i class="fa-solid fa-umbrella-beach"></i>
                  {{ item.name }}
                </div>
                <div class="address">
                  {{ item.endereco }}
                </div>
              </div>
            </li>
          </a>
        </ng-container>
      </ul>
    </div>
    <div class="mapa mr-5">
      <app-map [locations]="locations"></app-map>
    </div>
  </div>
</div>
